import { render, staticRenderFns } from "./chooseGoods.vue?vue&type=template&id=771e6f61&scoped=true&"
import script from "./chooseGoods.vue?vue&type=script&lang=js&"
export * from "./chooseGoods.vue?vue&type=script&lang=js&"
import style0 from "./chooseGoods.vue?vue&type=style&index=0&id=771e6f61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771e6f61",
  null
  
)

export default component.exports